import { toast } from 'sonner';
import { Link2, Mail } from 'lucide-react';

export const ShareBar = ({ url, text, testId = 'share-bar' }) => {
  const enc = encodeURIComponent;
  const copy = () => { navigator.clipboard.writeText(url); toast.success('Link copied'); };
  const btn = 'w-10 h-10 rounded-full border border-[#FAF7F2]/30 flex items-center justify-center text-[#FAF7F2] transition-colors duration-200 hover:bg-[#C5A059] hover:text-[#2D1037] hover:border-[#C5A059]';
  return (
    <div className="flex items-center gap-3" data-testid={testId}>
      <span className="text-xs uppercase tracking-[0.2em] text-[#FAF7F2]/60 mr-1">Share</span>
      <button onClick={copy} className={btn} data-testid="share-copy-link" aria-label="Copy link"><Link2 size={16} /></button>
      <a href={`https://wa.me/?text=${enc(`${text} ${url}`)}`} target="_blank" rel="noopener noreferrer" className={`${btn} text-xs font-semibold`} data-testid="share-whatsapp" aria-label="Share on WhatsApp">WA</a>
      <a href={`https://www.facebook.com/sharer/sharer.php?u=${enc(url)}`} target="_blank" rel="noopener noreferrer" className={`${btn} text-sm font-semibold`} data-testid="share-facebook" aria-label="Share on Facebook">f</a>
      <a href={`mailto:?subject=${enc(text)}&body=${enc(`${text}\n${url}`)}`} className={btn} data-testid="share-email" aria-label="Share by email"><Mail size={16} /></a>
    </div>
  );
};
